import { Link } from "react-router-dom";
import { LogoFull } from "./Logo";
import { useStore } from "@/context/StoreContext";

export const Footer = () => {
  const { openOrder } = useStore();

  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative border-t border-white/[0.07] bg-[#05070B]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="inline-block bg-slate-100 rounded-2xl px-4 py-2.5">
              <LogoFull size={40} />
            </div>
            <p className="text-slate-500 text-sm mt-6 leading-relaxed max-w-xs">
              Plug &amp; Play GPS-sporing for elsykkel.
            </p>
            <p className="text-slate-600 text-xs mt-3">Apexa Link er et produkt fra CLSF AS</p>
          </div>
          <div>
            <p className="mono text-[11px] tracking-[0.28em] uppercase text-slate-500 mb-5">Snarveier</p>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>
                <a href="#abonnement" onClick={(e) => go(e, "#abonnement")} data-testid="footer-plans-link" className="hover:text-cyan-300 transition-colors">
                  Abonnement og priser
                </a>
              </li>
              <li>
                <a href="#kontakt" onClick={(e) => go(e, "#kontakt")} data-testid="footer-contact-link" className="hover:text-cyan-300 transition-colors">
                  Kontakt oss
                </a>
              </li>
              <li>
                <Link to="/vilkar" data-testid="footer-terms-link" className="hover:text-cyan-300 transition-colors">
                  Vilkår og betingelser
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="mono text-[11px] tracking-[0.28em] uppercase text-slate-500 mb-5">Kom i gang</p>
            <p className="text-sm text-slate-400 mb-5">Klar til å sikre elsykkelen din?</p>
            <button
              onClick={() => openOrder()}
              data-testid="footer-order-button"
              className="font-display font-bold bg-[#FF4800] hover:bg-[#ff5d1f] text-white px-7 py-3 rounded-full text-sm transition-all duration-300 hover:shadow-[0_0_28px_rgba(255,72,0,0.45)] hover:-translate-y-0.5"
            >
              Bestill abonnement
            </button>
          </div>
        </div>
        <div className="border-t border-white/[0.06] mt-16 pt-8">
          <p className="mono text-[11px] tracking-[0.2em] uppercase text-slate-600" data-testid="footer-company">© 2026 CLSF AS</p>
        </div>
      </div>
    </footer>
  );
};
